import { Component, Input } from '@angular/core';
import { Shape } from './models/skeleton-loader.interface';

@Component({
  selector: 'idp-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent {
  @Input() shape: Partial<Shape> = {
    horizontalRectangle: {
      display: true,
      count: 3
    }
  };

  gridStyle(count: number | undefined) {
    return {
      gridTemplateColumns: `repeat(${count ? count : 3}, 1fr)`
    };
  }

  countArray(count: number | undefined) {
    return [...Array(count ? count : 3).keys()];
  }
}
